package team.platforma.chatdata.database

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import kotlin.Unit
import team.platforma.chatdata.database.chatdata.newInstance
import team.platforma.chatdata.database.chatdata.schema
import team.platforma.chatdata.table.DraftQueries
import team.platforma.chatdata.table.MokChatQueries
import team.platforma.chatdata.table.MokMessageQueries

public interface ChatDatabase : SuspendingTransacter {
  public val draftQueries: DraftQueries

  public val mokChatQueries: MokChatQueries

  public val mokMessageQueries: MokMessageQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = ChatDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): ChatDatabase =
        ChatDatabase::class.newInstance(driver)
  }
}
